import React, { memo, useState } from 'react'
import { useRecordContext, useTranslate } from 'react-admin'
import { Box, CircularProgress, Dialog, DialogContent, TextField } from '@mui/material'

import { MapperComponent } from './MapperComponentBusinessRule'
import Button from '@mui/material/Button/Button'
import { CreateCustomVar } from './CreateCustomVar'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { TextInput } from 'src/components/uiElements/fields/TextInput'

export const AdapterToMapperJson = memo(
  ({
    json,
    showJsonInput,
    jsonMapper,
    loading,
    selectedRuleType,
    ruleLiquidationTypes,
    getStaticJson,
    setJson,
    setIsAddVar,
    setShowJsonInput,
    onlyView = false,
  }) => {
    const translate = useTranslate()
    const record = useRecordContext()
    const [addVarDialog, setAddVarDialog] = useState(false)
    const [newVariable, setNewVariable] = useState({key:'', value:0})

    const onAddVar = () =>{
      setAddVarDialog(true)
    }

    const onSubmitNewVariable = () =>{
      setIsAddVar(true)
      let auxjson = {}
      if(json){
        auxjson = {...JSON.parse(json)}
        
        auxjson['data']['item'][newVariable.key] = newVariable.value
        
      } else {
        auxjson = {data:{item:{[newVariable.key]:newVariable.value}}}
      }
      setJson(JSON.stringify(auxjson))
      setAddVarDialog(false)
      setNewVariable({key:'', value:0})
    }

    if (!onlyView) {
      return (
        <Box className='json-mapper'>
          <Box>
            <Button
              variant={showJsonInput ? 'outlined' : 'contained'}
              size='small'
              className='button'
              onClick={() => getStaticJson()}
            >
              {translate('ra.field.select_default_json')}
            </Button>
            <Button
              variant={showJsonInput ? 'contained' : 'outlined'}
              size='small'
              className='button'
              onClick={() => {
                setShowJsonInput(true)
                setJson('')
              }}
            >
              {translate('ra.field.write_json_manually')}
            </Button>
            <Button
              size='small'
              className='button'
              variant='contained'
              onClick={onAddVar}
            >
              {'Agregar variable'}
            </Button>
            <Button
              size='small'
              className='button'
              variant='contained'
              onClick={()=>{
                navigator.clipboard.writeText(JSON.stringify(record?.request ?? ''))
              }}
            >
              {translate('ra.action.copy_json')}
            </Button>
          </Box>

          <Box style={{ display: 'flex', minHeight: 400 }}>
            <Box style={{ display: 'flex', flexDirection: 'column', width: '60%' }}>
              {showJsonInput && (
                <Box marginTop={5}>
                  <TextInput
                    multiline
                    rows={5}
                    source='json'
                    label=''
                    value={json}
                    onChange={(e) => setJson(e.target.value)}
                  />
                </Box>
              )}

              <Box
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: 400,
                  padding: 10,
                }}
              >
                {loading ? (
                  <CircularProgress />
                ) : (
                  <MapperComponent data={jsonMapper || {}} setShowJsonInput={setShowJsonInput} />
                )}
              </Box>
            </Box>

            <Box style={{ width: '40%' }}>
              <EditInputsWrap label={translate('ra.title.create_custom_var')}>
                <CreateCustomVar selectedRuleType={selectedRuleType} ruleLiquidationTypes={ruleLiquidationTypes} />
              </EditInputsWrap>
            </Box>
          </Box>
          <Dialog open={addVarDialog} onClose={()=>setAddVarDialog(false)}>
                <DialogContent>
                  <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField 
                      value={newVariable.key} 
                      onChange={(val)=>setNewVariable({...newVariable,key:val.target.value})} 
                      label='Clave' 
                      size='small' 
                      style={{margin:'10px'}}
                    />
                    <TextField 
                      label='Valor' 
                      size='small' 
                      type='number' 
                      value={newVariable.value} 
                      onChange={(val)=>setNewVariable({...newVariable,value:val.target.value})} 
                      style={{margin:'10px'}}
                    />
                  </div>
                  <div style={{display:'flex', flexDirection:'row', margin:'15px',justifyContent:'space-between'}}>
                    <Button
                      variant='outlined'
                      color='error'
                      onClick={()=>setAddVarDialog(false)}
                    >
                      {translate('ra.action.cancel')}
                    </Button>
                    <Button
                      variant='contained'
                      color='primary'
                      disabled={!newVariable.key}
                      onClick={onSubmitNewVariable}
                    >
                      {translate('ra.action.to_confirm')}
                    </Button>
                  </div>
                </DialogContent>
          </Dialog>
        </Box>
      )
    }
  }
)
